import React, { useMemo, useState } from 'react';
import { HelmetProvider } from 'react-helmet-async';
import { useNavigate } from 'react-router-dom';
import { SEO } from '../components/shared/SEO';
import { Header } from '../components/layout/Header';
import { Footer } from '../components/layout/Footer';
import { MobileFooterNav } from '../components/layout/MobileFooterNav';
import { MobileHomeHeader } from '../components/MobileHomeHeader';
import { LocationModal } from '../components/modals/LocationModal';
import { NowFeaturedCategories } from '../components/now/NowFeaturedCategories';
import { NowHeroCarousel } from '../components/now/NowHeroCarousel';
import { NowProductRail } from '../components/now/NowProductRail';
import { NowPromotionCarousel } from '../components/now/NowPromotionCarousel';
import { NowQuickCategories } from '../components/now/NowQuickCategories';
import { NowStickyCart } from '../components/now/NowStickyCart';
import { NowBrandsCarousel, NowNeedsCarousel } from '../components/now/NowVisualCarousels';
import { healthProducts, babyProducts } from '../data/products';
import { useStore } from '../lib/store';
type LocationValue = {
  name: string;
} | null;
export function NowHomePage() {
  const navigate = useNavigate();
  const [locationModalOpen, setLocationModalOpen] = useState(false);
  const [selectedLocation, setSelectedLocation] = useState<LocationValue>(null);
  const cart = useStore(state => state.cart);
  const cartCount = useStore(state => state.cartCount());
  const total = useStore(state => state.cartTotal());
  const nowProducts = useMemo(() => healthProducts.map(product => ({
    ...product,
    expressDelivery: true
  })), []);
  const bestSellers = useMemo(() => [...healthProducts.slice(2), ...babyProducts.slice(0, 3)].map(product => ({
    ...product,
    expressDelivery: true,
    isBestSeller: true
  })), []);
  const featuredProducts = useMemo(() => healthProducts.slice(0, 5).map(product => ({
    ...product,
    expressDelivery: true
  })), []);
  return <HelmetProvider data-id="element-7423" data-mp="1ilg2cim2hcty">
      <div className="min-h-screen bg-[#f7f8fb]" data-id="element-7424" data-mp="1amtjhp8cq0i3">
        <SEO title="NOW 120 | Pharmacy essentials delivered fast" data-id="element-7425" data-mp="1alihnuygv2tm" />

        <div className="hidden md:block" data-id="element-7426" data-mp="15orzn233px5k">
          <Header locationModalOpen={locationModalOpen} setLocationModalOpen={setLocationModalOpen} selectedLocation={selectedLocation} setSelectedLocation={setSelectedLocation} showAnnouncement data-id="element-7427" data-mp="15nqg0980s2c8" />
        </div>

        <main className="pb-24 pt-0 md:pb-0 md:pt-[var(--header-height-desktop)]" data-id="element-7428" data-mp="ror0ps6eczsq">
          <div className="md:hidden" data-id="element-7429" data-mp="mq7ctm88tdxq">
            <MobileHomeHeader selectedLocation={selectedLocation} onOpenLocationModal={() => setLocationModalOpen(true)} transparentAtTop showExperienceSwitcher activeExperience="innova" data-id="element-7430" data-mp="mr8rs1sdqkkq" />
          </div>

          <NowHeroCarousel data-id="element-7431" data-mp="2czqtudgztxpo" />
          <NowFeaturedCategories data-id="element-7432" data-mp="282h5701fhq2w" />
          <NowQuickCategories data-id="element-7433" data-mp="281fifyb1vf5c" />

          <div className="mx-auto max-w-7xl space-y-9 px-4 py-7 md:space-y-12 md:px-6 md:py-10" data-id="element-7434" data-mp="2827grgw17qzb">
            <NowPromotionCarousel data-id="element-7435" data-mp="2fkor1pbqf9tc" />

            <NowProductRail title="Deal Zone" subtitle="Fast-delivery offers available near you" viewAllLink="/offers" products={nowProducts} data-id="element-7436" data-mp="2kktb1pbummob" />

            <NowProductRail title="Best Sellers" subtitle="Popular products near you" viewAllLink="/category/medicines?from=now" products={bestSellers} data-id="element-7437" data-mp="2amdjjl8wtbea" />

            <NowNeedsCarousel data-id="element-7438" data-mp="33aj6menfrcha" />

            <NowProductRail title="Vitamins & Supplements" subtitle="Support your everyday wellness" viewAllLink="/category/vitamins-supplements?from=now" products={featuredProducts} data-id="element-7439" data-mp="33dosll0rpy8s" />

            <NowBrandsCarousel data-id="element-7440" data-mp="3hb3qle537ecd" />
          </div>
        </main>

        <div className="hidden md:block" data-id="element-7441" data-mp="3m224y86im2cz"><Footer data-id="element-7442" data-mp="3m2bw3z3aqfk9" /></div>
        <MobileFooterNav data-id="element-7443" data-mp="3m3n0o14kfrcf" />
        {cart.length > 0 && <NowStickyCart itemCount={cartCount} total={total} onViewCart={() => navigate('/cart')} data-id="element-7444" data-mp="1yea1ktd5fdxv" />}
        <LocationModal isOpen={locationModalOpen} onClose={() => setLocationModalOpen(false)} onSelectLocation={setSelectedLocation} data-id="element-7445" data-mp="1tdclqnfm2vzj" />
      </div>
    </HelmetProvider>;
}